var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGardin2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 208.48 11.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#010101;stroke-miterlimit:11.34;stroke-width:0.85px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path823-3",
    className: "cls-1",
    d: "M2.05,7.25c9.37,0,16.71,10.83,26.07,10.83S44.82,7.25,54.19,7.25s16.67,10.83,26,10.83S96.93,7.25,106.29,7.25",
    transform: "translate(-2.05 -6.83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path823-3-2",
    className: "cls-1",
    d: "M106.29,7.25c9.37,0,16.71,10.83,26.07,10.83S149,7.25,158.43,7.25s16.67,10.83,26,10.83S201.17,7.25,210.53,7.25",
    transform: "translate(-2.05 -6.83)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardin2);
export default __webpack_public_path__ + "static/media/Gardin 2.129146471934955a5d4ac04f83af312b.svg";
export { ForwardRef as ReactComponent };